import {createZonedDateTime} from "./createZonedDateTime";

export function addDateRangeToChartBox(startDateTimeAsString, endDateTimeAsString, timeZoneOffset) {
    const startDate = createZonedDateTime(startDateTimeAsString, timeZoneOffset);
    const endDate = createZonedDateTime(endDateTimeAsString, timeZoneOffset);

    let formattedDateTimeRange = `${startDate.getDate()}.${startDate.getMonth() + 1} - ${endDate.getDate()}.${endDate.getMonth() + 1}.${endDate.getFullYear()}`;
    document.querySelector('.c-box-forecast-week-chart .c-box__header__meta').innerHTML = formattedDateTimeRange
}

//TODO remove if migrated to ChartDataFormatter
export function adjustHAsixTicks(chartDateTable, options) {
// Set X-Axis Labels
    let xTicks = [];
    for (let i = 0; i < chartDateTable.getNumberOfRows(); i++) {
        xTicks.push({
            v: chartDateTable.getValue(i, 0),
            f: chartDateTable.getFormattedValue(i, 0)
        });
    }

    options.hAxis.ticks = xTicks;
}

export function formatDateTimeWithPatternAndTimeOffset(chartDateTable, options, timeZoneOffset) {

    // Datetime formating for proper timezone
    let dateTimeFormatter = new google.visualization.DateFormat({
        timeZone: timeZoneOffset,
        pattern: options.hAxis.format
    });

    // Reformat our data.
    dateTimeFormatter.format(chartDateTable, 0);

}
